import { useEffect } from 'react';

/**
 * Sets document title, meta description, and canonical URL for the current page.
 * Also updates key Open Graph tags so link previews per route are accurate.
 */
export default function usePageMeta({ title, description, path = '', noindex = false }) {
  useEffect(() => {
    const siteName = 'RealOTK';
    const fullTitle = title ? `${title} | ${siteName}` : `${siteName} — Professional Disciplinarian in Western Washington`;
    document.title = fullTitle;

    const setMeta = (attr, name, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('name', 'description', description);
    setMeta('property', 'og:title', fullTitle);
    setMeta('property', 'og:description', description);
    setMeta('name', 'twitter:title', fullTitle);
    setMeta('name', 'twitter:description', description);

    // Canonical
    const canonicalUrl = `https://realotk.com${path.startsWith('/') ? path : '/' + path}`.replace(/\/$/, '') || 'https://realotk.com/';
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', canonicalUrl);
    setMeta('property', 'og:url', canonicalUrl);
    setMeta('name', 'twitter:url', canonicalUrl);

    // Robots
    setMeta('name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large');
  }, [title, description, path, noindex]);
}
